module.exports = __webpack_public_path__ + "img/banner.ab0e7b25.jpeg";